/* eslint-disable no-unused-vars */
import React from 'react'
import './home.css'
import Programes from '../../components/Programes'
// import Header from './components/Header'
import Header from '../../components/Header'
import Values from '../../components/Value'
import Faq from '../../components/Faq'
import Testmniol from '../../components/Testmniol'





function Home() {
  return (
    <>
      <Header/>
      <Programes />
      <Values />
      <Faq/>
      <Testmniol/>



     
    </>
  )
}

export default Home
